import axios from 'axios';
import { API, PAYMENT_TYPE } from '../../constants';
import _ from 'lodash';
import { push as PushRouter } from 'connected-react-router';

const createAction = name => ({
  OPEN_DIALOG_SF_PLUS_ACCOUNT_NOT_LINKED: `${name}_OPEN_DIALOG_SF_PLUS_ACCOUNT_NOT_LINKED`,
  CLOSE_DIALOG_SF_PLUS_ACCOUNT_NOT_LINKED: `${name}_CLOSE_DIALOG_SF_PLUS_ACCOUNT_NOT_LINKED`,
  OPEN_DIALOG_SF_PLUS_BALANCE: `${name}_OPEN_DIALOG_SF_PLUS_BALANCE`,
  CLOSE_DIALOG_SF_PLUS_BALANCE: `${name}_CLOSE_DIALOG_SF_PLUS_BALANCE`,
  OPEN_DIALOG_PHONE_NUMBER: `${name}_OPEN_DIALOG_PHONE_NUMBER`,
  CLOSE_DIALOG_PHONE_NUMBER: `${name}_CLOSE_DIALOG_PHONE_NUMBER`,
  OPEN_DIALOG_SF_PLUS_VALIDATE_PIN: `${name}_OPEN_DIALOG_SF_PLUS_VALIDATE_PIN`,
  CLOSE_DIALOG_SF_PLUS_VALIDATE_PIN: `${name}_CLOSE_DIALOG_SF_PLUS_VALIDATE_PIN`,
  SF_PLUS_VALIDATE_PIN_SUCCESS: `${name}_SF_PLUS_VALIDATE_PIN_SUCCESS`,
  SF_PLUS_VALIDATE_PIN_FAILED: `${name}_SF_PLUS_VALIDATE_PIN_FAILED`,

  SF_PLUS_ORDERING_FETCHING: `${name}_SF_PLUS_ORDERING_FETCHING`,
  SF_PLUS_ORDERING_SUCCESS: `${name}_SF_PLUS_ORDERING_SUCCESS`,
  SF_PLUS_ORDERING_FAILED: `${name}_SF_PLUS_ORDERING_FAILED`,

  CLOSE_DIALOG_SF_PLUS_ORDERING_FAILED: `${name}_CLOSE_DIALOG_SF_PLUS_ORDERING_FAILED`,

  SF_PLUS_PAYMENT_SUCCESS: `${name}_SF_PLUS_PAYMENT_SUCCESS`,
  SF_PLUS_PAYMENT_FAILED: `${name}_SF_PLUS_PAYMENT_FAILED`,

  CLOSE_DIALOG_SF_PLUS_PAYMENT_SUCCESS: `${name}_CLOSE_DIALOG_SF_PLUS_PAYMENT_SUCCESS`,
  CLOSE_DIALOG_SF_PLUS_PAYMENT_FAILED: `${name}_CLOSE_DIALOG_SF_PLUS_PAYMENT_FAILED`,

  CREDIT_CARD_ORDERING_FETCHING: `${name}_CREDIT_CARD_ORDERING_FETCHING`,
  CREDIT_CARD_ORDERING_SUCCESS: `${name}_CREDIT_CARD_ORDERING_SUCCESS`,
  CREDIT_CARD_ORDERING_FAILED: `${name}_CREDIT_CARD_ORDERING_FAILED`,


  KPAYMENT_CHARGE_FETCHING: `${name}_KPAYMENT_CHARGE_FETCHING`,
  KPAYMENT_CHARGE_SUCCESS: `${name}_KPAYMENT_CHARGE_SUCCESS`,
  KPAYMENT_CHARGE_FAILED: `${name}_KPAYMENT_CHARGE_FAILED`,


  OPEN_DIALOG_CHECKOUT_POLICY: `${name}_OPEN_DIALOG_CHECKOUT_POLICY`,
  CLOSE_DIALOG_CHECKOUT_POLICY: `${name}_CLOSE_DIALOG_CHECKOUT_POLICY`,

  OPEN_DIALOG_CHECKOUT_TAX_ADDRESS_CHANGE: `${name}_OPEN_DIALOG_CHECKOUT_TAX_ADDRESS_CHANGE`,
  CLOSE_DIALOG_CHECKOUT_TAX_ADDRESS_CHANGE: `${name}_CLOSE_DIALOG_CHECKOUT_TAX_ADDRESS_CHANGE`,

  OPEN_DIALOG_THAIQR: `${name}_OPEN_DIALOG_THAIQR`,
  CLOSE_DIALOG_THAIQR: `${name}_CLOSE_DIALOG_THAIQR`,
  THAIQR_ORDERING_FETCHING: `${name}_THAIQR_ORDERING_FETCHING`,
  THAIQR_ORDERING_SUCCESS: `${name}_THAIQR_ORDERING_SUCCESS`,
  THAIQR_ORDERING_FAILED: `${name}_THAIQR_ORDERING_FAILED`,

  GET_BRANCH_PENDING: `${name}_GET_BRANCH_PENDING`,
  GET_BRANCH_SUCCESS: `${name}_GET_BRANCH_SUCCESS`,
  GET_BRANCH_FAILED: `${name}_GET_BRANCH_FAILED`,

  OPEN_DIALOG_FURTHER_INFORMATION: `${name}_OPEN_DIALOG_FURTHER_INFORMATION`,
  CLOSE_DIALOG_FURTHER_INFORMATION: `${name}_CLOSE_DIALOG_FURTHER_INFORMATION`
});

export const CHEKCOUT = createAction('CHEKCOUT');

export const OpenDialogCheckOutPolicy = type => dispatch => {
  dispatch({
    type: CHEKCOUT.OPEN_DIALOG_CHECKOUT_POLICY,
    payload: type
  });
};

export const CloseDialogCheckOutPolicy = () => dispatch => {
  dispatch({ type: CHEKCOUT.CLOSE_DIALOG_CHECKOUT_POLICY });
};

export const OpenDialogSfPlusAccountNotLinked = () => dispatch => {
  dispatch({ type: CHEKCOUT.OPEN_DIALOG_SF_PLUS_ACCOUNT_NOT_LINKED });
};

export const CloseDialogSfPlusAccountNotLinked = () => dispatch => {
  dispatch({ type: CHEKCOUT.CLOSE_DIALOG_SF_PLUS_ACCOUNT_NOT_LINKED });
};

export const OpenDialogSfPlusBalance = () => dispatch => {
  dispatch({ type: CHEKCOUT.OPEN_DIALOG_SF_PLUS_BALANCE });
};

export const CloseDialogSfPlusBalance = () => dispatch => {
  dispatch({ type: CHEKCOUT.CLOSE_DIALOG_SF_PLUS_BALANCE });
};

export const OpenDialogPhoneNumber = () => dispatch => {
  dispatch({ type: CHEKCOUT.OPEN_DIALOG_PHONE_NUMBER });
};

export const CloseDialogPhoneNumber = () => dispatch => {
  dispatch({ type: CHEKCOUT.CLOSE_DIALOG_PHONE_NUMBER });
};

export const OpenDialogSfPlusValidatePin = () => dispatch => {
  dispatch({ type: CHEKCOUT.OPEN_DIALOG_SF_PLUS_VALIDATE_PIN });
};

export const CloseDialogSfPlusValidatePin = () => dispatch => {
  dispatch({ type: CHEKCOUT.CLOSE_DIALOG_SF_PLUS_VALIDATE_PIN });
};

export const OpenDialogFurtherInformation = () => dispatch => {
  dispatch({ type: CHEKCOUT.OPEN_DIALOG_FURTHER_INFORMATION });
};

export const CloseDialogFurtherInformation = () => dispatch => {
  dispatch({ type: CHEKCOUT.CLOSE_DIALOG_FURTHER_INFORMATION });
};

export const SFPlusValidatePin = (inputPin, delivery) => (
  dispatch,
  getState
) => {
  const { login } = getState();
  const masterPin = login.firebaseSfPlusUser.pin;

  if (_.isEqual(masterPin, inputPin)) {
    dispatch({ type: CHEKCOUT.SF_PLUS_VALIDATE_PIN_SUCCESS });
    dispatch(SFPlusOrdering(PAYMENT_TYPE.SFPLUS, delivery));
  } else {
    dispatch({
      type: CHEKCOUT.SF_PLUS_VALIDATE_PIN_FAILED,
      error: 'Pin not match'
    });
  }
};

export const SFPlusOrdering = (
  paymentType,
  deliveryAddressAndShippingCost
) => async (dispatch, getState) => {
  const { login, cart, language } = getState();
  dispatch({ type: CHEKCOUT.SF_PLUS_ORDERING_FETCHING });

  try {
    const params = dispatch(prepareOrderingParams(deliveryAddressAndShippingCost, paymentType));

    const result = await axios
      .post(API.ORDERING_SF_PLUS, params, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': language.currentLanguage
        }
      })
      .then(res => res.data)
      .catch(error => Promise.reject(error));

    if (result.vistatransno) {
      dispatch(SFPlusConfirmPayment(paymentType, result));
    } else {
      dispatch({
        type: CHEKCOUT.SF_PLUS_ORDERING_FAILED,
        error: result.message
      });
    }
  } catch (error) {
    dispatch({
      type: CHEKCOUT.SF_PLUS_ORDERING_FAILED,
      error: error.message
    });
  }
};

export const CloseDialogSfPlusOrderingFailed = () => dispatch => {
  dispatch({ type: CHEKCOUT.CLOSE_DIALOG_SF_PLUS_ORDERING_FAILED });
};

export const SFPlusConfirmPayment = (type, data) => async (
  dispatch,
  getState
) => {
  try {
    const { login, language } = getState();
    const params = {
      sfPlusMember: login.firebaseSfPlusUser.card_no,
      pin: login.firebaseSfPlusUser.pin,
      paymentType: type,
      orderId: data.orderId,
      confirmPayment: ''
    };

    const result = await axios
      .post(API.CONFIRM_PAYMENT, params, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': language.currentLanguage
        }
      })
      .then(res => res.data)
      .catch(error => Promise.reject(error));

    if (result.status) {
      dispatch({
        type: CHEKCOUT.SF_PLUS_PAYMENT_SUCCESS,
        payload: result.message
      });
      dispatch(PushRouter(`/paymentsuccess?orderType=${result.orderType}`));
    } else {
      ////vista error
      dispatch({
        type: CHEKCOUT.SF_PLUS_PAYMENT_FAILED,
        error: result.message
      });
      dispatch(PushRouter('/paymentfailure'));
    }
  } catch (error) {
    dispatch({
      type: CHEKCOUT.SF_PLUS_PAYMENT_FAILED,
      error: error.message
    });
  }
};

export const CloseDialogSfPlusPaymentSuccess = () => async dispatch => {
  await dispatch({ type: CHEKCOUT.CLOSE_DIALOG_SF_PLUS_PAYMENT_SUCCESS });
  window.location.href = window.location.origin;
};

export const CloseDialogSfPlusPaymentFailed = () => dispatch => {
  dispatch({ type: CHEKCOUT.CLOSE_DIALOG_SF_PLUS_PAYMENT_FAILED });
};

export const CreditCardOrdering = deliveryAddressAndShippingCost => async (
  dispatch,
  getState
) => {
  const { language, payment } = getState();
  dispatch({ type: CHEKCOUT.CREDIT_CARD_ORDERING_FETCHING });

  try {
    const params = dispatch(prepareOrderingParams(deliveryAddressAndShippingCost, payment.defaultCreditCardPaymentGatway));
    const result = await axios
      .post(API.ORDERING_CREDIT_CARD, params, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': language.currentLanguage
        }
      })
      .then(res => res.data)
      .catch(error => Promise.reject(error));

    if (result.vistatransno) {
      dispatch({
        type: CHEKCOUT.CREDIT_CARD_ORDERING_SUCCESS,
        payload: result
      });
    } else {
      dispatch({
        type: CHEKCOUT.CREDIT_CARD_ORDERING_FAILED,
        error: result.message
      });
    }
  } catch (error) {
    dispatch({
      type: CHEKCOUT.CREDIT_CARD_ORDERING_FAILED,
      error: error.message
    });
  }
};

export const OpenDialogCheckoutTaxAddressChange = () => dispatch => {
  dispatch({ type: CHEKCOUT.OPEN_DIALOG_CHECKOUT_TAX_ADDRESS_CHANGE });
};

export const CloseDialogCheckoutTaxAddressChange = () => dispatch => {
  dispatch({ type: CHEKCOUT.CLOSE_DIALOG_CHECKOUT_TAX_ADDRESS_CHANGE });
};

export const ThaiQROrdering = deliveryAddressAndShippingCost => async (
  dispatch,
  getState
) => {
  const { login, cart, language } = getState();
  dispatch({ type: CHEKCOUT.THAIQR_ORDERING_FETCHING });

  try {
    const params = dispatch(prepareOrderingParams(deliveryAddressAndShippingCost, 'Thai QR'))

    const result = await axios
      .post(API.ORDERING_THAIQR, params, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': language.currentLanguage
        }
      })
      .then(res => res.data)
      .catch(error => Promise.reject(error));

    if (result.vistatransno) {
      dispatch({
        type: CHEKCOUT.THAIQR_ORDERING_SUCCESS,
        payload: result
      });
    } else {
      dispatch({
        type: CHEKCOUT.THAIQR_ORDERING_FAILED,
        error: result.message
      });
    }
  } catch (error) {
    dispatch({
      type: CHEKCOUT.THAIQR_ORDERING_FAILED,
      error: error.message
    });
  }
};

export const ThaiQRConfirmPayment = paymentStatus => async dispatch => {
  if (paymentStatus) {
    dispatch({ type: CHEKCOUT.CLOSE_DIALOG_THAIQR });
    dispatch(PushRouter('/paymentsuccess'));
  } else {
    dispatch({ type: CHEKCOUT.CLOSE_DIALOG_THAIQR });
    dispatch(PushRouter('/paymentfailure'));
  }
};

export const ThaiQrInquirePayment = (vistatransno, done) => async (dispatch, getState) => {
  const { language } = getState();
  const result = await axios
    .get(`${API.INQUIRE_THAIQR}?vistatransno=${vistatransno}`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': language.currentLanguage
      }
    })
    .then(res => res.data)
    .catch(error => Promise.reject(error));
  if (result.status == "PAID") dispatch(ThaiQRConfirmPayment(true))
  else done();
};

export const ThaiQrCancelPayment = (vistatransno, done) => async (dispatch, getState) => {
  const { language } = getState();
  const result = await axios
    .get(`${API.CANCEL_THAIQR}?vistatransno=${vistatransno}`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': language.currentLanguage
      }
    })
    .then(res => res.data)
    .catch(error => Promise.reject(error));
  if (result.status == "PAID") dispatch(ThaiQRConfirmPayment(true))
  done();
};

export const OpenDialogThaiQR = () => dispatch => {
  dispatch({ type: CHEKCOUT.OPEN_DIALOG_THAIQR });
};

export const CloseDialogThaiQR = () => async dispatch => {
  await dispatch({ type: CHEKCOUT.CLOSE_DIALOG_THAIQR });
};

export const GetShippingCost = (totalPrice, items, address) => async (dispatch, getState) => {
  try {
    const { language } = getState();
    var shippingCost = await axios
      .post(API.GET_SHIPPING_COST, { totalPrice, items, address }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': language.currentLanguage
        }
      })
      .then(res => {
        return res.data;
      })
      .catch(err => Promise.reject(err));

    return shippingCost;
  } catch (err) {
    console.log(err);
  }
};

export const KPaymentCharge = ( params) => async (dispatch, getState) => {
  dispatch({ type: CHEKCOUT.KPAYMENT_CHARGE_FETCHING });
  try {
    const { language } = getState();

    const result = await axios
      .post(API.KPAYMENT_CHARGE, params, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': language.currentLanguage
        }
      })
      .then(res => res.data)
      .catch(error => Promise.reject(error));
      console.log(result);
      window.location.replace(result.redirectUrl);
  } catch (err) {
    console.log(err);
    dispatch({
      type: CHEKCOUT.KPAYMENT_CHARGE_FAILED,
      //error: error.message
    });
  }
};

export const KPaymentCancelPayment = (vistatransno, done) => async (dispatch, getState) => {
  dispatch({
    type: CHEKCOUT.THAIQR_ORDERING_FAILED,
    error: "cancel"
  });
};

export const GetKPaymentHash = (bankFormatAmount, invoice) => async () => {
  try {
    const result = await axios
      .post(
        API.GET_K_PAYMENT_HASH,
        { bankFormatAmount, invoice },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      .then(res => res.data)
      .catch(err => Promise.reject(err));
    return result;
  } catch (err) {
    return err;
  }
};

export const Get2c2pHash = (bankFormatAmount, invoice) => async () => {
  try {
    const result = await axios
      .post(
        API.GET_2C2P_HASH,
        { bankFormatAmount, invoice },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      .then(res => res.data)
      .catch(err => Promise.reject(err));
    return result;
  } catch (err) {
    return err;
  }
};

export const GetPickupDate = () => async _ => {
  return await axios.get(API.GET_PICKUP_DATE)
    .then(res => new Date(res.data).toLocaleDateString('th-TH', { dateStyle: 'full' }));
}

const prepareOrderingParams = ({
  name,
  lastName,
  phoneNumber,
  address,
  district,
  subDistrict,
  province,
  zipCode,
  shippingCost,
  TaxInvoiceCheckbox,
  taxInvoiceAddress,
  deliveryType,
  branchId,
  email
}, paymentType) => (dispatch, getState) => {
  const { login, cart, checkout } = getState();
  const { isAuthenticated } = login;
  let splitName = name || lastName ? [name, lastName] : login.firebaseAuth?.displayName?.split(" ");
  return {
    paymentType: paymentType,
    customerId: isAuthenticated ? login.firebaseAuth.uid : null,
    name: splitName[0],
    lastName: splitName[1],

    address: address || "",
    district: district || "",
    subDistrict: subDistrict || "",
    province: province || "",
    zipCode: zipCode || "",

    phoneNumber: phoneNumber,

    deliveryType: deliveryType,
    branchId: branchId || null,

    email: email || login.firebaseAuth.email,
    pin: login.firebaseSfPlusUser?.pin || '',
    shippingCost: shippingCost.toFixed(2),
    saleOrder: checkout.checkOutData.map(item => ({
      itemId: item.itemId,
      price: item.price.toString(),
      amount: item.qty.toString(),
      itemSizeId: item.sizeId,
      promotionCodeDirect: item.promotionCodeDirect,
      promotionCodeDiscountCode: item.promotionCodeDiscountCode
    })),
    sfPlusMember: login.firebaseSfPlusUser?.card_no || phoneNumber,
    taxName: taxInvoiceAddress.name,
    taxLastName: taxInvoiceAddress.lastName,
    taxPhoneNumber: taxInvoiceAddress.phoneNumber,
    taxAddress: taxInvoiceAddress.address,
    taxDistrict: taxInvoiceAddress.district,
    taxSubDistrict: taxInvoiceAddress.subDistrict,
    taxProvince: taxInvoiceAddress.province,
    taxZipCode: taxInvoiceAddress.zipCode,
    taxId: taxInvoiceAddress.taxId,
    taxIsRequest: TaxInvoiceCheckbox ? 'Y' : 'N',
    taxEmail: taxInvoiceAddress.email,
    promotionCartSelected: _.chain(cart.promotionCartSelected)
      .groupBy("promotionid")
      .map((value, key) => ({ promotionid: key, cart: value.map(item => ({ itemId: item.itemId, qty: item.qty })) }))
      .value(),
    cartItemType: checkout.checkOutData.every(o => o?.type === "voucher") ? "voucher" : "item",
    discountCode: cart?.discountCode || ""
  };
}

export const getBranch = () => async (dispatch, getState) => {
  try {
    const { language } = getState();
    return await axios.get(API.GET_BRANCH, {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': language.currentLanguage
      }
    })
      .then(res => res.data)
      .catch(err => Promise.reject(err));
  } catch (err) {
    return err;
  }
}

export const getBranchSetting = () => async (dispatch, getState) => {
  try {
    const { language } = getState();
    return await axios.get(API.GET_BRANCH_SETTING, {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': language.currentLanguage
      }
    })
      .then(res => res.data)
      .catch(err => Promise.reject(err));
  } catch (err) {
    return err;
  }
}